import React from 'react'
import { Typography } from '@material-ui/core'

const Title: React.FC = ({ children }) => {
  return <Typography variant='h2'>{children}</Typography>
}

export default Title
